const initialState = {
    message: 'Welcome back',
    level: 'info',
    icon: 'tick',
    id: '1',
};

export default initialState;
